<template>
    <div style="padding-bottom:50px">
        <div @click="redirectPreviousUrl"
            style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
            <p>
                <a-icon type="double-left" />
            </p>
            <p>Go Back </p>

        </div>
        <div style="margin-top:30px;background:#fff">

            <div style="padding:60px">
                <a-row>
                    <a-col :span="12">
                        <a-row>
                            <a-col :span="8">
                                <!-- <div style="background-color:#ccc;;width: 70px; height: 37px;margin-top:5px;"></div> -->
                            </a-col>
                            <a-col :span="12">
                                <div>
                                    <!-- <span style="font-size:20px; font-weight:bolder">{{supplierDetails.name}}</span>
                                    <span style="font-size:13px;display:block">{{supplierDetails.address}}</span>
                                     -->
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="12">
                        <div style="float:right">
                            <span style="font-size:20px; font-weight:bolder">PURCHASE ORDER</span>
                            <span style="font-size:13px;display:block">DATE: {{ currentDate }}</span>
                            <!-- <span style="font-size:13px;display:block">#34566</span> -->
                        </div>
                    </a-col>
                </a-row>
                <a-row style="margin-top:30px">
                    <a-col :span="12">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <a-row>
                                <a-col :span="8">
                                    Supplier:
                                </a-col>
                                <a-col :span="14">
                                    <span style="font-weight:bolder">
                                        <a-form-model>
                                            <a-input v-model="supplierName" placeholder="Supplier name?" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="supplierAddress" placeholder="Address" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="supplierCity" placeholder="Region" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="supplierCountry" placeholder="Country" />
                                        </a-form-model>
                                    </span>
                                </a-col>
                            </a-row>
                        </div>

                    </a-col>
                    <a-col :span="12">
                        <div style="border: 2px solid #ccc;padding: 20px;border-left: hidden;">
                            <a-row>
                                <a-col :span="8">
                                    Ship To:
                                </a-col>
                                <a-col :span="14">
                                    <span style="font-weight:bolder">
                                        <a-form-model>
                                            <a-select show-search placeholder="Choose your suplier"
                                                option-filter-prop="children" v-model="destionation"
                                                :filter-option="filterOption" @change="onDistributionChange">
                                                <a-select-option
                                                    v-for="distributionCenter in availableDistributionCenters"
                                                    :key="distributionCenter.id" v-bind:value="distributionCenter.id">
                                                    {{ distributionCenter.name }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="shipAddress" placeholder="Address" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="shipCity" placeholder="Region" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="shipCountry" placeholder="Country" />
                                        </a-form-model>
                                    </span>
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                </a-row>
                <a-row style="margin-top:30px;display: flex; justify-content: space-between">
                    <a-col :span="12">
                        <div style="font-weight:bolder">Shipping Method</div>
                        <div style="">
                            <a-select default-value="Land" v-model="shippingMethod" style="width: 120px">
                                <a-select-option value="Land">
                                    Land
                                </a-select-option>
                                <a-select-option value="Air">
                                    Air
                                </a-select-option>
                                <a-select-option value="Sea">
                                    Sea
                                </a-select-option>
                            </a-select>
                        </div>
                    </a-col>

                    <a-col :span="12" style="text-align: end;">
                        <div style="font-weight:bolder">Delivery Date</div>
                        <div style="">
                            <a-form-model>
                                <a-date-picker v-model="deliveryDate" @change="onDeliveryDateChange" />
                            </a-form-model>
                        </div>
                    </a-col>
                </a-row>
                <div style="margin-top:20px;">
                    <div style="display: flex; justify-content: flex-end;padding: 14px;">
                        <a-button @click="handleAdd"
                            style="height:33px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                            icon="plus">
                            Add Product
                        </a-button>
                    </div>

                    <a-table bordered :columns="columns" :data-source="tableData" :pagination="false"
                        :loading="tableLoading" :scroll="{ x: 20, y: 400 }" class="modalTable">
                        <template slot="quantity" slot-scope="text, record">
                            <quantity-editable-cell :text="text"
                                @change="onQauntityCellChange(record.key, 'quantity', $event)" />
                        </template>
                        <template slot="unitPrice" slot-scope="text, record">
                            <unit-price-editable-cell :text="text"
                                @change="onUnitPriceCellChange(record.key, 'unitPrice', $event)" />
                        </template>
                        <!-- <template slot="name" slot-scope="text, record">
                            <product-name-editable-cell :text="text" :tableData="tableData" @change="onProductNameCellChange(record.key, 'name', $event)" />
                        </template> -->
                        <template slot="category" slot-scope="text, record">
                            <category-editable-cell :text="text"
                                @change="onCategoryNameCellChange(record.key, 'category', $event)" />
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a-popconfirm v-if="tableData.length" title="Delete this product?"
                                @confirm="() => onDelete(record.key)">
                                <a-icon style="cursor:pointer;display:flex;justify-content:center;"
                                    type="minus-circle-o" />
                            </a-popconfirm>
                        </template>
                    </a-table>
                </div>

                <a-row type="flex" justify="end" style="margin-top:10px;">
                    <a-col :span="12">
                        <a-form-model-item label="Terms" ref="" prop="">
                            <a-textarea class="descInputText" v-model="shippinTerm" :maxLength="300"
                                placeholder="Shipping Terms" :auto-size="{ minRows: 3, maxRows: 5 }" />
                            <small style="color:red">Maximun characters is 300</small>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-row style="display:flex;justify-content: flex-end;">
                            <a-col style="font-weight:bolder;font-size: 19px;" :span="8">Sub Total: </a-col>
                            <a-col :span="12" style="font-size: 19px;font-weight:bolder;">Ksh {{ displayTotalAmount
                                }}</a-col>
                        </a-row>
                        <a-row style="display:flex;justify-content: flex-end;">
                            <a-col style="font-weight:bolder;font-size: 19px;" :span="8">Discount: </a-col>
                            <a-col style="display:flex; height:20px;font-size: 19px;" :span="12">
                                <a-form-model>
                                    <a-input-number v-model="discount" />
                                </a-form-model>
                            </a-col>
                        </a-row>
                        <a-row style="display:flex;justify-content: flex-end;padding-top:30px">
                            <a-col style="font-weight:bolder;font-size: 25px;" :span="10">Grand Total: </a-col>
                            <a-col style="font-weight:bolder;font-size: 25px;" :span="12">Ksh {{ displayGrandTotal
                                }}</a-col>
                        </a-row>
                    </a-col>
                </a-row>

                <div style="display:flex;justify-content: center;padding-top: 40px;">
                    <a-button @click="handlePreview"
                        style="border-raduis:5px; background: #418a49; color:#fff;height:50px;width:200px;"> Preview
                        <a-icon type="eye" /> </a-button>
                </div>
            </div>

        </div>
        <a-modal class="modalStyle" :visible="addProductVisible" :footer="null" @cancel="handleAddProductCancel">
            <div style="display:flex;justify-content: center;">
                <img class="img_size" src="../../assets/img/inventory_1.png" />
            </div>
            <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Add New Product</p>
            <div>
                <a-form-model ref="addProductForm" :model="newProductForm" :rules="rules">
                    <a-row type="flex" justify="center" align="middle">
                        <a-col :span="16">
                            <a-form-model-item label="Select Product" ref="productId" prop="productId">
                                <a-select show-search placeholder="Choose your product" option-filter-prop="children"
                                    v-model="newProductForm.productId" :filter-option="filterOption"
                                    @change="onProductChange">
                                    <a-select-option v-for="product in availableProducts" :key="product.id"
                                        v-bind:value="product.id">
                                        {{ product.brandName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                    </a-row>

                    <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                        <a-spin class="spinner" :spinning="loading" />
                    </div>
                    <div v-show="showAlertMsg" style="display:flex;justify-content: center;padding-bottom: 10px;">
                        <a-alert message="Product already exist, kindly choose a different product." type="error" />
                    </div>

                    <a-form-model-item
                        style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                        <a-button :loading="modalLoading" @click="addProduct"
                            style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                            Add Product
                        </a-button>
                    </a-form-model-item>

                </a-form-model>
            </div>
        </a-modal>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';


const columns = [
    {
        title: 'Product Name',
        dataIndex: 'name',
        key: "name",
        // scopedSlots: { customRender: 'name' },
        width: 250,
    },
    // {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     scopedSlots: { customRender: 'category' },
    //     key:"category",
    // 	width: 250,
    // },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity",
        scopedSlots: { customRender: 'quantity' },
        // width: 200,
    },
    {
        title: 'Selling Price',
        dataIndex: 'unitPrice',
        key: "unitPrice",
        scopedSlots: { customRender: 'unitPrice' },
        // width: 200,
    },
    {
        title: 'Line Total',
        dataIndex: 'lineTotal',
        key: "lineTotal"
        // width: 200,
    },
    {
        title: 'Action',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
    },
]

import QuantityEditableCell from './common/QuantityEditableCell';
import UnitPriceEditableCell from './common/UnitPriceEditableCell';
// import ProductNameEditableCell from './common/ProductNameEditableCell';
import CategoryEditableCell from './common/CategoryEditableCell';

export default {
    name: "PurchasedReceipt",
    components: {
        QuantityEditableCell,
        UnitPriceEditableCell,
        // ProductNameEditableCell,
        CategoryEditableCell
    },
    data() {
        return {
            columns,
            addProductVisible: false,
            modalLoading: false,
            tableData: [],
            loading: false,
            tableLoading: false,
            discount: 0,
            deliveryDate: null,
            supplierName: "",
            supplierAddress: "",
            supplierCity: "",
            supplierCountry: "",
            destionation: "",
            shipAddress: "",
            shipCity: "",
            shipCountry: "",
            shippingMethod: "Land",
            shippinTerm: "",
            originalData: [],
            showAlertMsg: false,
            newProductForm: {
                productId: "",

            },
            newPreOrderProduct: {},
            availableProducts: [],
            availableDistributionCenters: [],
            params: {
                page: 1,
                perPage: 10,
                searchBy: {},
                sortBy: {}
            },
            supplierDetails: {},
            rules: {
                maxQuantity: [
                    { required: true, message: 'Please enter quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^[0-9]*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                productId: [
                    { required: true, message: 'Please select product', trigger: 'change' },
                ],

                quantity: [
                    { required: true, message: 'Please enter quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],

                price: [
                    { required: true, message: 'Please enter price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters(['getPreViewInfo']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.unitPrice && item.quantity) {
                    return parseFloat(item.unitPrice) * item.quantity
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)

        },
        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount).toFixed(2)
        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'getClientProducts', 'getAllDistributionCenters']),
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        onDeliveryDateChange(date, dateString) {
            this.deliveryDate = dateString
            // console.log("deliveryDate", this.deliveryDate);
        },
        onProductChange(value) {
            // console.log("value  | ",value)
            let filterProduct = this.availableProducts.filter(product => product.id === value)
            // console.log("filterProduct  | ",filterProduct)
            this.newPreOrderProduct = filterProduct[0]
        },
        onDistributionChange(value) {
            if (value) {
                let filterDistributionCenter = this.availableDistributionCenters.filter(distributionCentre => distributionCentre.id === value)

                this.shipAddress = filterDistributionCenter[0].address
                this.destionation = filterDistributionCenter[0].name
            }
        },
        handleAddProductCancel() {
            this.addProductVisible = false;
        },
        handleAdd() {
            this.addProductVisible = true;
        },
        redirectPreviousUrl() {
            this.$router.back()
        },
        handlePreview() {
            let previewData = {
                discount: this.discount,
                deliveryDate: this.deliveryDate,
                supplierName: this.supplierName,
                supplierAddress: this.supplierAddress,
                supplierCity: this.supplierCity,
                supplierCountry: this.supplierCountry,
                destionation: this.destionation,
                shipAddress: this.shipAddress,
                shipCity: this.shipCity,
                shipCountry: this.shipCountry,
                shippingMethod: this.shippingMethod,
                shippinTerm: this.shippinTerm,
                tableData: this.tableData,
                originalData: this.originalData,
                supplierDetails: this.supplierDetails
            }
            this.setPreviewInfo(JSON.stringify(previewData));

            this.$router.push('/preview-receipt').catch(() => { });
        },
        onProductNameCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            // console.log("target | ", target)
            if (target) {
                target[dataIndex] = value.name;
                target['key'] = value.name;
                target['id'] = parseInt(value.id);
                this.tableData = tableData;
            }
            // console.log("dataSource | ", this.tableData)
        },
        onCategoryNameCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            // console.log("target | ", target)
            if (target) {
                target[dataIndex] = value.name;
                target['key'] = value.name;
                target['id'] = parseInt(value.id);
                this.tableData = tableData;
            }
            // console.log("dataSource | ", this.tableData)
        },
        onUnitPriceCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            if (target) {
                target[dataIndex] = value;
                target["lineTotal"] = parseInt(value) * parseInt(target.quantity);
                this.tableData = tableData;
            }
        },
        onQauntityCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            // console.log("target | ", target)
            if (target) {
                target[dataIndex] = value;
                target["lineTotal"] = parseInt(target.unitPrice) * parseInt(value);
                this.tableData = tableData;
            }
        },
        onDelete(key) {
            // console.log("key | ", key)
            const tableData = [...this.tableData];
            this.tableData = tableData.filter(item => item.key !== key);
        },

        addProduct() {
            this.$refs.addProductForm.validate(valid => {
                if (valid) {
                    // let request_data = {
                    //     id:this.getOrder.id,
                    //     data: {
                    //         productId : this.newProductForm.productId,
                    //         maxQuantity: this.newProductForm.maxQuantity,
                    //     }
                    // }
                    // console.log("exit product | ", this.checkExistingProduct(this.newProductForm.productId))
                    // console.log("request_data | ", request_data)
                    // console.log("id | ", this.getOrder.id)
                    // console.log("request_data | ", request_data)
                    if (this.checkExistingProduct(this.newProductForm.productId)) {
                        this.showAlertMsg = true;
                    } else {
                        this.showAlertMsg = false;
                        this.modalLoading = true;

                        // console.log("newPreOrderProduct | ", this.newPreOrderProduct)

                        let productObj = {
                            key: this.randomString(10),
                            id: this.newPreOrderProduct.id,
                            name: this.newPreOrderProduct.brandName,
                            category: this.newPreOrderProduct.categoryName,
                            quantity: "0",
                            unitPrice: this.newPreOrderProduct.purchasePrice.toString(),
                            lineTotal: parseInt(0) * parseInt(this.newPreOrderProduct.purchasePrice)
                        }
                        this.tableData.push(productObj)
                        this.modalLoading = false;
                        this.addProductVisible = false

                    }
                } else {
                    return false;
                }
            })
        },
        checkExistingProduct(productId) {
            return this.tableData.some(product => product.id === productId)
        },

        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },


    },
    created() {
        if (this.getAllDistributionCenters) {
            this.getAllDistributionCenters().then(response => {
                //    
                if (response.status === 200) {
                    this.availableDistributionCenters = response.data.data;
                } else {
                    console.log('Error | ', response)
                }
            }, error => {
                console.log('Error | ', error)
            })
        }
        // console.log("getPreViewInfo | ", this.getPreViewInfo)
        if (this.getPreViewInfo) {
            // console.log("getPreViewInfo | ", this.getPreViewInfo)
            let result = JSON.parse(this.getPreViewInfo)

            this.discount = result.discount,
                this.deliveryDate = result.deliveryDate,
                this.supplierName = result.supplierName,
                this.supplierAddress = result.supplierDetails.address,
                this.supplierCity = result.supplierCity,
                this.supplierCountry = result.supplierCountry,
                this.destionation = result.destionation,
                this.shipAddress = result.shipAddress,
                this.shipCity = result.shipCity,
                this.shipCountry = result.shipCountry,
                this.shippingMethod = result.shippingMethod,
                this.shippinTerm = result.shippinTerm,
                this.tableData = result.tableData
            this.originalData = result.originalData
            this.supplierDetails = result.supplierDetails
        }
        if (this.getClientProducts) {
            this.params.page = -1
            this.params.perPage = -1
            this.getClientProducts(this.params).then(response => {
                //    
                if (response.status === 200) {
                    this.availableProducts = response.data.data;
                } else {
                    console.log('Error | ', response)
                }
            }, error => {
                console.log('Error | ', error)
            })
        }
        // if(this.getSupplierDetails){
        //     this.getSupplierDetails(this.getPreViewInfo.supplierId)
        // }
    }
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}
</style>